import { render, staticRenderFns } from "./CirclesOverlapDashboardItem.vue?vue&type=template&id=e7cf588e"
import script from "./CirclesOverlapDashboardItem.vue?vue&type=script&lang=js"
export * from "./CirclesOverlapDashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7cf588e')) {
      api.createRecord('e7cf588e', component.options)
    } else {
      api.reload('e7cf588e', component.options)
    }
    module.hot.accept("./CirclesOverlapDashboardItem.vue?vue&type=template&id=e7cf588e", function () {
      api.rerender('e7cf588e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/CirclesOverlapDashboardItem.vue"
export default component.exports